/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState, useRef } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import { isProduction } from 'src/config/index';
import PropTypes from 'prop-types';
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import Table from 'src/components/table/Table';
import { set } from 'lodash';
import { getEndOfDay, getStartOfDay } from 'src/utils/DadeUtils';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { caseResetAction, caseSearchAction } from '../case-container/actions/CaseActions';
import { headerShowAction } from '../header-container/actions/HeaderActions';
import RoutingUtil from 'src/utils/RoutingUtil';
import OpenNewTabLink from 'src/components/OpenNewTabLink';
import { userSearchAPI } from 'src/api/UserApi';
import { PRODUCT_CATEGORY_TYPES_LIST } from '../product-container/ProductConstants';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import UserDropDown from 'src/business-components/UserDropDown';
import CommissionManagerDropDown from 'src/business-components/CommissionManagerDropDown';
import FormikSelect from 'src/components/formik/FormikSelect';
import { PAYOUT } from '../company-container/CompanyConstants';
import FormikCheckBox from 'src/components/formik/FormikCheckBox';
import { caseInvoiceCreateAPI } from 'src/api/CaseApi';
import LinkComponent from 'src/components/LinkComponent';
import { useHistory } from 'react-router';
import { useParams } from "react-router";
import { useEffect } from 'react';
// import { ExportReactCSV } from 'src/components/excel/ExportReactCSV';


const RenderFilters = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        // errors,
        // touched, 
        // forceRefreshSearchContainer, 
        activityList,
    } = props;

    return (
        <div>
            <div className="border-top my-3" />
            <div className="card mt-3">
                <div className="card-body">
                    <h5 className="card-title">
                        Invoice Details
                        {/* <ExportReactCSV csvData={ExportInExcel} fileName={"CaseStatusReport-" + new Date().toLocaleDateString()} /> */}
                    </h5>
                    <Table
                        rowDeletedCheckPath="deleted"
                        recordsPerPage={50}
                        searchData={{
                            data: activityList.data,
                            count: activityList.count,
                            currentPage: 0,
                        }}
                        columns={{
                            group: [
                                {
                                    display: 'Case No',
                                    path: 'case.caseCode',
                                },
                                {
                                    display: 'Invoice No',
                                    path: 'invoice.invoiceNo',
                                },
                                {
                                    display: 'Invoice Date',
                                    type: Date,
                                    path: 'invoice.invoiceDate',
                                },
                                {
                                    display: 'Commission',
                                    path: 'invoice.commissionId.commissionName',
                                }
                            ],
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

RenderFilters.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    values: PropTypes.any.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    // activityList: PropTypes.array.isRequired,

};

// setting submit button state after submitting
const filterDefaultValues = {
    verifierId: '',
    clientId: '',
    branchId: '',
    CaseFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    CaseToDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    caseId: '',
    caseStatus: '',
    overAllcaseStatus: '',
};

const Invoice = () => {
    const [
        filterInitialValues,
        setFilterInitialValues,
    ] = useState({
        ...filterDefaultValues,
    });

    const [
        currentProductCategory,
        setProductCategory,
    ] = useState();

    // REDUX
    const dispatch = useDispatch();
    const { caseId } = useParams();



    const {
        search: {
            data: searchResults,
            count,
        },
    } = useSelector((state) => state.CaseReducer, shallowEqual);

    const activitiesFromSearch = useMemo(() => {
        if (!searchResults) {
            return [];
        }
        const PrepairData = [];
        searchResults.forEach((caseInfo) => {
            caseInfo.invoiceDetails.forEach((invoice) => {
                PrepairData.push({
                    case: caseInfo,
                    invoice: invoice
                });
            });
        });

        const results = {
            data: PrepairData,
            count
        };

        return results;
    }, [
        searchResults,
        currentProductCategory,

    ]);



    const onSearchSubmit = useEffect(() => {
        if (!caseId) {
            dispatch(headerShowAction({
                data: 'There must at least one filter to be added.',
            }));
            return;
        }

        let where = {
        };
        // CASEID
        if (caseId) {
            where._id = caseId;
        }

        dispatch(caseSearchAction({
            where,
            sortBy: 'ts',
            sortOrder: -1,
            fullTextSearch: false,
            pageLength: 30,
        }));
    }, [
        dispatch,
    ]);

    const onClear = useCallback(() => {
        dispatch(caseResetAction());
        setFilterInitialValues({
            ...filterDefaultValues,
        });
    }, [
        dispatch,
    ]);

    return (
        <div>
            <Formik
                onSubmit={onSearchSubmit}
                onClear={onClear}
                enableReinitialize
                initialValues={filterInitialValues}
            // validationSchema={}
            >
                {(formikProps) => (
                    <RenderFilters
                        // forceRefreshSearchContainer={forceRefreshSearchContainer}
                        onClear={onClear}
                        {...formikProps}
                        activityList={activitiesFromSearch}
                    />
                )}
            </Formik>
        </div>
    );
};

export default Invoice;
